// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fd9c93ed","451":"89483859","455":"cd1a8512","644":"2b85b56f"}[chunkId] + ".chunk.js";
};